import gql from "graphql-tag";

export const USER_QUERY = gql`
  query GetUserQuery {
    me {
      id
      email
      name
      firstName
      surName
      phone
      postalCode
      city
      street
      roles {
        name
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/ProfileQuery/queries.ts